/**
 * Crea el boton de restar y su comportamiento
 * @param {*} scene
 */
export function crearBotonRestar(scene) {
  scene.botonRestar = scene.add
    .image(498, 470, "botonRestarDesactivado")
    .setInteractive();

  scene.botonRestar.on("pointerover", () => {
    if (!scene.noVaMas) {
      if (scene.botonSumarActivado ) {
        scene.botonRestar.setTexture("botonRestarDesactivadoHover");
      }
    }
  });

  scene.botonRestar.on("pointerout", () => {
    if (!scene.noVaMas) {
      if (scene.botonSumarActivado) {
        scene.botonRestar.setTexture("botonRestarDesactivado");
      }
    }
  });

  scene.botonRestar.on("pointerdown", () => {
    if (!scene.noVaMas) {
      if (scene.botonSumarActivado) {
        scene.botonRestar.setTexture("botonRestarDesactivadoPressed");
      }
    }
  });

  scene.botonRestar.on("pointerup", () => {
    if (!scene.noVaMas) {
      if (scene.botonSumarActivado) {

        scene.botonSumarActivado = false;
        scene.botonSumar.setTexture("botonSumarDesactivado");

        if (scene.botonRestar.input?.isOver) {
          scene.botonRestar.setTexture("botonRestarActivado");
        } else {
          scene.botonRestar.setTexture("botonRestarActivado");
        }
      }
    }
  });
}
